export const WEFAT_PULL_DOWN_REFRESH_API_NAMES = Object.freeze([
    'stopPullDownRefresh',
]);
export class WxPullDownRefreshRuntimeError extends Error {
    code;
    errCode;
    errMsg;
    api = 'stopPullDownRefresh';
    remediation;
    constructor(code, reason, remediation, cause) {
        const errMsg = `stopPullDownRefresh:fail ${reason}`;
        super(`${code} ${errMsg}`);
        this.name = 'WxPullDownRefreshRuntimeError';
        this.code = code;
        this.errCode = code;
        this.errMsg = errMsg;
        this.remediation = remediation;
        if (cause !== undefined)
            Object.defineProperty(this, 'cause', { value: cause });
    }
}
const CALLBACK_KEYS = new Set(['success', 'fail', 'complete']);
function isPlainRecord(value) {
    if (value === null || typeof value !== 'object' || Array.isArray(value))
        return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
function optionError(reason) {
    return new WxPullDownRefreshRuntimeError('WF6151', reason, 'Pass an optional plain object containing only success, fail, and complete callback functions.');
}
function driverError(error) {
    if (error instanceof WxPullDownRefreshRuntimeError)
        return error;
    return new WxPullDownRefreshRuntimeError('WF6150', error instanceof Error ? error.message : String(error), 'Install the generated page viewport controller before application scripts call wx.stopPullDownRefresh.', error);
}
function readCallbacks(raw) {
    if (raw === undefined)
        return {};
    if (!isPlainRecord(raw))
        throw optionError('options must be a plain object');
    for (const key of Reflect.ownKeys(raw)) {
        const descriptor = typeof key === 'string' ? Object.getOwnPropertyDescriptor(raw, key) : undefined;
        if (typeof key !== 'string' || !CALLBACK_KEYS.has(key)) {
            throw optionError(`unsupported option field ${String(key)}`);
        }
        if (descriptor === undefined || !('value' in descriptor)) {
            throw optionError(`option field ${key} must be a direct data property`);
        }
        if (descriptor.value !== undefined && typeof descriptor.value !== 'function') {
            throw optionError(`${key} must be a function when provided`);
        }
    }
    return raw;
}
function invokeCallback(callback, value, kind, report) {
    if (callback === undefined)
        return;
    try {
        callback(value);
    }
    catch (error) {
        if (report !== undefined) {
            try {
                report(error, 'stopPullDownRefresh', kind);
                return;
            }
            catch (reportError) {
                queueMicrotask(() => { throw reportError; });
                return;
            }
        }
        queueMicrotask(() => { throw error; });
    }
}
export function createPullDownRefreshWxApis(options) {
    if (!isPlainRecord(options) || !isPlainRecord(options.driver)) {
        throw new TypeError('createPullDownRefreshWxApis requires a plain driver object');
    }
    if (typeof options.driver.stopPullDownRefresh !== 'function') {
        throw new TypeError('pull-down refresh driver requires stopPullDownRefresh');
    }
    if (options.onCallbackError !== undefined && typeof options.onCallbackError !== 'function') {
        throw new TypeError('onCallbackError must be a function when provided');
    }
    return Object.freeze({
        stopPullDownRefresh(raw) {
            let callbacks;
            try {
                callbacks = readCallbacks(raw);
            }
            catch (error) {
                return Promise.reject(error);
            }
            const task = Promise.resolve()
                .then(() => options.driver.stopPullDownRefresh())
                .then(() => Object.freeze({ errMsg: 'stopPullDownRefresh:ok' }));
            if (callbacks.success === undefined && callbacks.fail === undefined && callbacks.complete === undefined) {
                return task.catch((error) => { throw driverError(error); });
            }
            void task.then((result) => {
                invokeCallback(callbacks.success, result, 'success', options.onCallbackError);
                invokeCallback(callbacks.complete, result, 'complete', options.onCallbackError);
            }, (error) => {
                const failure = driverError(error);
                invokeCallback(callbacks.fail, failure, 'fail', options.onCallbackError);
                invokeCallback(callbacks.complete, failure, 'complete', options.onCallbackError);
            });
            return undefined;
        },
    });
}
//# sourceMappingURL=pull-down-refresh-adapter.js.map